var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSystemAlertFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29.09 7.419a6 6 0 0 1 7.934 1.974l.221.367 20.69 37.356a6 6 0 0 1-4.837 8.893l-.411.014H11.312a6 6 0 0 1-5.444-8.524l.195-.383L26.747 9.761A6 6 0 0 1 29.09 7.42ZM32 42.67a2.663 2.663 0 1 0 0 5.326 2.663 2.663 0 0 0 0-5.326Zm-.006-21.343a2.667 2.667 0 0 0-2.648 2.357l-.017.31.005 13.336.018.311a2.667 2.667 0 0 0 5.297-.002l.018-.31-.005-13.336-.018-.311a2.667 2.667 0 0 0-2.65-2.355Z",
  fill: "#C6C6C6"
})));
export default SvgIcSystemAlertFilled;